/*
 * variant-media-filter.js
 * ---------------------------------------------------------------------------
 * PDP gallery: show only the images that match the selected metal color and
 * hide the rest.
 *
 * Shopify only allows ONE featured image per variant, so Dawn can only swap a
 * single image on variant change. Product photos here are color-tagged in the
 * filename (see snippets/media-color.liquid), and product-media-gallery.liquid
 * stamps each media item/thumbnail with data-media-color (white|yellow|rose|
 * platinum|neutral) and the <media-gallery> element with data-selected-color.
 *
 * The actual hiding is done in CSS (custom.css) keyed off data-selected-color,
 * which the server renders on first paint (no flash). This script only UPDATES
 * data-selected-color when the shopper changes the metal color, and re-activates
 * a visible image if the active one gets hidden.
 *
 * Fail-safe: if the product has no metal-color option, or the images aren't
 * color-tagged, nothing is changed.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  // Map a metal-color option value to a media-color token.
  // Rose/Yellow/Platinum map directly; White gold and anything unrecognized
  // map to the white set. (Platinum gets a white fallback in apply() when the
  // product has no platinum-specific images.)
  function metalToken(value) {
    var v = (value || '').toLowerCase();
    if (v.indexOf('rose') > -1) return 'rose';
    if (v.indexOf('yellow') > -1) return 'yellow';
    if (v.indexOf('platinum') > -1) return 'platinum';
    return 'white';
  }

  // Find the currently selected metal color value (radios or select).
  function getSelectedMetal() {
    var radios = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      if (/metal/i.test(radios[i].name || '')) return radios[i].value;
    }
    var selects = document.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var s = selects[j];
      var wrap = s.closest ? s.closest('.product-form__input') : null;
      var lbl = wrap ? (wrap.querySelector('legend, label') || {}).textContent : '';
      if (/metal/i.test(s.name || '') || /metal/i.test(lbl || '')) return s.value;
    }
    return null;
  }

  function apply() {
    var metal = getSelectedMetal();
    if (!metal) return; // product without a metal-color option -> leave gallery as-is
    var selected = metalToken(metal);

    var galleries = document.querySelectorAll('media-gallery');
    for (var g = 0; g < galleries.length; g++) {
      var gallery = galleries[g];
      var items = gallery.querySelectorAll('.product__media-item[data-media-color]');
      if (!items.length) continue; // no color data -> nothing to filter

      // Platinum shows platinum-specific images when they exist, otherwise the
      // white set (platinum and white gold look alike).
      var effective = selected;
      if (effective === 'platinum' && !gallery.querySelector('.product__media-item[data-media-color="platinum"]')) {
        effective = 'white';
      }

      // CSS (keyed off this attribute) does the hiding.
      gallery.setAttribute('data-selected-color', effective);

      // If the active image was hidden (e.g. switching to White/Platinum, which
      // have no variant featured_media so Dawn doesn't re-activate), promote the
      // first still-visible image.
      var active = gallery.querySelector('.product__media-item.is-active');
      if (active && window.getComputedStyle(active).display === 'none') {
        var firstVisible = null;
        for (var i = 0; i < items.length; i++) {
          if (window.getComputedStyle(items[i]).display !== 'none') { firstVisible = items[i]; break; }
        }
        if (firstVisible) {
          var id = firstVisible.getAttribute('data-media-id');
          if (id && typeof gallery.setActiveMedia === 'function') {
            try { gallery.setActiveMedia(id, true); } catch (e) {}
          }
        }
      }
    }
  }

  function onChange(e) {
    var el = e.target;
    if (!el) return;
    var isVariantControl =
      (el.matches && (el.matches('input[type="radio"]') || el.matches('select'))) &&
      ((el.closest && (el.closest('variant-radios') || el.closest('variant-selects'))) ||
        /metal/i.test(el.name || ''));
    if (isVariantControl) {
      // Run after Dawn's own updateMedia() has swapped the featured image.
      window.requestAnimationFrame(apply);
    }
  }

  function init() {
    apply(); // reaffirm server state / handle any active-image edge cases
    document.addEventListener('change', onChange);
    // Backup hook: Dawn re-publishes variantChange after its async section fetch.
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { window.requestAnimationFrame(apply); });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
